// +-------------------------------------------------------------
// | Created by WebStorm.
// +-------------------------------------------------------------
// | User: msmile
// +-------------------------------------------------------------
// | Date: 2024/2/2
// +-------------------------------------------------------------
// |Time: 14:11
// +-------------------------------------------------------------
import {useRoute, useRouter} from "vue-router";
import {computed, ref, watch} from "vue";
import {useUserStore} from "@/store/module/user";

export function useTab() {

    const route = useRoute();
    const router = useRouter();
    const routes = router.getRoutes()
    const currentPath = computed(() => route.path);
    const userStore = useUserStore();

    const tabs = ref([]);
    const tabsCache = []

    if (routes) {
        routes.forEach(route => {
            if (route.meta && route.meta.affix) {
                tabs.value.push({
                    ...route.meta,
                    id: route.path,
                    name: route?.name
                })
                tabsCache.push(route.path)
            }
        })
    }
    if (route.path && !tabsCache.includes(route.path)) {
        const path = routes.find(item => item.path === route.path)
        path && tabs.value.push({
            ...path.meta,
            id: route.path,
            name: route?.name,
        })
    }
    if(userStore.keepAliveList){
        Object.assign(tabs.value,userStore.keepAliveList)
    }
    const to = (id) => {
        router.push(id);
    };

    const close = (id) => {
        tabs.value = tabs.value.filter((ele) => ele.id != id);
        to(tabs.value[0].id);
    };

    const closeAll = () => {
        tabs.value = tabs.value.filter((ele) => ele.closable == false);
        to(tabs.value[0].id);
    };

    const closeCurrent = () => {
        tabs.value = tabs.value.filter((ele) => ele.id != currentPath.value);
        to(tabs.value[0].id);
    }

    const closeOther = () => {
        tabs.value = tabs.value.filter(
            (ele) => ele.closable == false || ele.id == currentPath.value
        );
    };

    watch(route, () => {
        let bool = false;
        tabs.value.forEach((tab) => {
            if (tab.id === route.path) {
                bool = true;
            }
        });
        if (!bool) {
            tabs.value.push({ ...route.meta,id: route.path, name: route?.name });
        }
        userStore.keepAliveList = tabs.value
    });

    return {
        to,
        close,
        closeAll,
        closeOther,
        closeCurrent,
        tabs,
        currentPath,
    };
}
